import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import CarDetails from './pages/CarDetails';
import Bookings from './pages/Bookings';
import Cars from './pages/Cars';
import About from './pages/About';
import Contacts from './pages/Contacts';
import Terms from './pages/Terms';
import AuthPage from './pages/AuthPage';
import Profile from './pages/Profile';
import AdminPanel from './pages/AdminPanel';
import { motion } from 'framer-motion';
import Footer from "./components/Footer";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Header from "./components/Header";
import AuthCheck from "./components/AuthCheck";
import ThankYou from './pages/ThankYou';
import Agreements from "./components/Agreement";
import Privacy from "./components/Privacy";
import ContactWidget from "./components/ContactWidget";


const pageVariants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};

function App() {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.5 }}
    >
    <Router>
      <AuthCheck />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cars" element={<Cars />} />
        <Route path="/cars/:carId" element={<CarDetails />} />
        <Route path="/bookings" element={<Bookings />} />
        <Route path="/about" element={<About />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/agreements" element={<Agreements />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
      <ContactWidget />
      <Footer />
    </Router>
    </motion.div>
  );
}

export default App;
